/*
 *
 * MeasurementDetailSimple reducer
 *
 */

import { fromJS } from "immutable"
import {
  GET_MEASURE_SIMPLE_SUCCESS,
  GET_MEASURE_SIMPLE_WATCHER,
  GET_MEASURE_SIMPLE_FAILED,
  UPDATE_MEASURE_WATCHER,
  UPDATE_MEASURE_SUCCESS,
  UPDATE_MEASURE_FAILED,
  REPROCESS_MEASURE_WATCHER,
  REPROCESS_MEASURE_SUCCESS,
  REPROCESS_MEASURE_FAILED
} from "./constants"

export const initialState = fromJS({
  isLoading: false,
  measureSimple: {},
  isLoadingMeasure: false,
  activeMeasure: [],
  isLoadingReprocess:false,
  activeReprocess:[]
})

function MeasurementDetailSimple(state = initialState, action) {
  switch (action.type) {
    case GET_MEASURE_SIMPLE_WATCHER:
      return state
      .set("isLoading", true)
      .set("measureSimple", {})
    case GET_MEASURE_SIMPLE_SUCCESS:
      return state
      .set("isLoading", false)
      .set("measureSimple", action.payload)
    case GET_MEASURE_SIMPLE_FAILED:
      return state
      .set("isLoading", false)
      .set("measureSimple", {})
      case UPDATE_MEASURE_WATCHER:
        return state.set("isLoadingMeasure", true)
      case UPDATE_MEASURE_SUCCESS:
        return state
          .set("isLoadingMeasure", false)
          .set("activeMeasure", action.payload)
      case UPDATE_MEASURE_FAILED:
        return state.set("isLoadingMeasure", false)
        case REPROCESS_MEASURE_WATCHER:
          return state.set("isLoadingReprocess", true)
        case REPROCESS_MEASURE_SUCCESS:
          return state
            .set("isLoadingReprocess", false)
            .set("activeReprocess", action.payload)
        case REPROCESS_MEASURE_FAILED:
          return state.set("isLoadingReprocess", false)
    default:
      return state
  }
}

export default MeasurementDetailSimple
